var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38462 16C1.01538 16 0.692308 15.8885 0.415385 15.6655C0.138462 15.4425 0 15.1823 0 14.885V8.8827C0 8.69686 0.0230769 8.53891 0.0692308 8.40883C0.115385 8.27875 0.2 8.15796 0.323077 8.04646L1.61538 6.63415C1.73846 6.52265 1.88077 6.44522 2.04231 6.40186C2.20385 6.3585 2.39528 6.33682 2.6166 6.33682H9.3834C9.60472 6.33682 9.79231 6.3585 9.94615 6.40186C10.1 6.44522 10.2385 6.52265 10.3615 6.63415L11.6769 8.04646C11.8 8.15796 11.8846 8.27875 11.9308 8.40883C11.9769 8.53891 12 8.69686 12 8.8827V14.885C12 15.1823 11.8615 15.4425 11.5846 15.6655C11.3077 15.8885 10.9846 16 10.6154 16H1.38462ZM1.77692 8.30662H10.2L9.35979 7.4518H2.60769L1.77692 8.30662ZM1.38462 9.4216V14.885H10.6154V9.4216H1.38462ZM6 5.77933L9.6 2.88037L8.67692 2.13705L6.69231 3.73519V0H5.30769V3.73519L3.32308 2.13705L2.4 2.88037L6 5.77933Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSell);
export default __webpack_public_path__ + "static/media/sell.43945edc.svg";
export { ForwardRef as ReactComponent };